import { FC } from 'react'
import { Colour } from '../constants'
import styles from '../SiteFooter/styles.module.scss'
import { Panel, PanelItem, PanelLayout } from '@/components/Panel'
import { useRichText } from '@/hooks/useRichText'
import { FooterSocialLink, SocialLinks } from './SocialLinks'
import { FooterLinkSectionProps, LinkSection } from './LinkSection'
import { DynamicImage } from '../DynamicImage'
import { LayoutData } from '@/context/LayoutDataContext'

type SiteFooterContentProps = {
  fields: LayoutData['footer']['fields']
}

export const SiteFooterContent: FC<SiteFooterContentProps> = ({ fields }) => {
  return (
    <footer>
      <Panel
        data-testid="footer"
        id="siteFooter"
        colour={Colour.black}
        className={styles.siteFooterPanel}
        short
        layout={PanelLayout.full}
      >
        <PanelItem>
          <div className={styles.signOffText}>{fields.signOffText}</div>
          <div className={styles.footerFlexContainer}>
            <div className={styles.socialContainer}>
              <SocialLinks
                links={fields.footerSocialLinks as FooterSocialLink[]}
              />
              <DynamicImage
                width={fields.logo.fields.file.details.image.width}
                height={fields.logo.fields.file.details.image.height}
                sizes="(max-width: 768px) 100vw"
                className={styles.siteLogo}
                image={fields.logo.fields.file.url}
                alt={fields.logo.fields.title}
              />
            </div>

            <div className={styles.footerLinksContainer}>
              {fields.footerLinkSections.map(
                (section: FooterLinkSectionProps, index: number) => (
                  <LinkSection key={index} {...section} />
                ),
              )}
            </div>
          </div>
          <div className={styles.legal}>
            <>{useRichText(fields.legalDisclaimer)}</>
          </div>
          <div className={styles.copyright}>
            Copyright {new Date().getFullYear()} &copy; {fields.copyrightOwner}
          </div>
        </PanelItem>
      </Panel>
    </footer>
  )
}
